import {Dimensions, Platform} from 'react-native';
import { CMSPath } from '../config/Constant';


/**
 * Helper Methods
 */
export const isIOS = () => {
  return Platform.OS === 'ios';
};

/**
 *
 * @returns
 */
export const isAndroid = () => {
  return Platform.OS === 'android';
};

export const isWeb = () => {
  return Platform.OS === 'web';
};

/**
 * return device width
 * @returns
 */
export const getDeviceWidth = () => {
  return Dimensions.get('window').width;
};

/**
 * return device height
 * @returns
 */
export const getDeviceHeight = () => {
  return Dimensions.get('window').height;
};

/**
 *
 * @param {*} url
 * @returns
 */
export function getCleanUrl(url) {

  if (!url || typeof url !== 'string') {
    return '';
  }

  if (url.startsWith('http')) {
    return url;
  }
  const cleanUrl = url.replace('../', '');
  return `${CMSPath}${cleanUrl}`;
}

export function getRequestImgUrl(url){
  const cleanUrl = url?.replace('../', '');
  return `${CMSPath}/cmsData/${cleanUrl}`;
}

/**
 *
 * @param {*} primaryUrl
 * @param {*} fallbackUrl
 * @returns
 */

export const getDefaultUrl = (primaryUrl, fallbackUrl) => {
  return primaryUrl === '' ? primaryUrl : fallbackUrl;
};


/**
 * 
 * @param {*} data 
 * @returns 
 */
export const cleanWidgetUrls = (data) => {
  return data.map(item => {
    return {
      ...item,
      btnImageUrl: getCleanUrl(item.btnImageUrl),
      widgetHeaderImageUrl: getCleanUrl(item.widgetHeaderImageUrl),
    };
  });
};


export const toBool = (param) => {
  if(!param || param == "false" || param == "FALSE"){
      return false;
  } else {
      return true;
  }
}

// New function to send messages based on platform
export const sendMessageToFrame = (ref, message) => {
  console.log("in sendMessageToFrame", message);
  
  const payload = typeof message == "string" ? message : JSON.stringify(message)
  if (isWeb()) {
      ref?.current?.contentWindow.postMessage( payload, '*');
  } else if (ref.current) {
      ref.current?.postMessage(payload);
  }
};


export const generateToken = (widgetName="") => {
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  return widgetName + Math.random().toString(36).substr(2, 9);
};


export const  calculateTimeDifference = (date1, date2, unit = 'second') =>  {
  console.log("date1, date2, unit",date1, date2, unit)
  var difference = date2.getTime() - date1.getTime();

  var daysDifference = Math.floor(difference/1000/60/60/24);
  difference -= daysDifference*1000*60*60*24

  var hoursDifference = Math.floor(difference/1000/60/60);
  difference -= hoursDifference*1000*60*60

  var minutesDifference = Math.floor(difference/1000/60);
  difference -= minutesDifference*1000*60

  var secondsDifference = Math.floor(difference/1000);

  if(unit == 'second') return secondsDifference;
  else if(unit == 'minute') return minutesDifference;
  else if(unit == 'hour') return hoursDifference;
  else if(unit == 'day') return daysDifference;
}


export const parseEventDataFromUrl = (url) => {
  const params = {};

  try {
    // Try native URL parsing
    const parsedUrl = new URL(url);
    for (const [key, value] of parsedUrl.searchParams.entries()) {
      params[key] = value;
    }
    return { params };
  } catch (e) {
    // Fallback if URL constructor fails
    try {
      const queryStart = url.indexOf('?');
      if (queryStart === -1 || queryStart === url.length - 1) {
        return { params };
      }

      const queryString = url.slice(queryStart + 1);
      for (const pair of queryString.split('&')) {
        if (!pair) continue;
        const [rawKey, rawValue] = pair.split('=');
        if (!rawKey) continue;

        const key = decodeURIComponent(rawKey.trim());
        const value = decodeURIComponent((rawValue || '').trim());

        params[key] = value;
      }

      return { params };
    } catch (fallbackErr) {
      return { params };
    }
  }
};
